/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseLinkGalleryPage } from './DatabaseLinkGalleryPage';
import {
    DatabaseLinkGalleryPageFromJSON,
    DatabaseLinkGalleryPageFromJSONTyped,
    DatabaseLinkGalleryPageToJSON,
} from './DatabaseLinkGalleryPage';
import type { DatabasePage } from './DatabasePage';
import {
    DatabasePageFromJSON,
    DatabasePageFromJSONTyped,
    DatabasePageToJSON,
} from './DatabasePage';

/**
 * 
 * @export
 * @interface DatabasePages
 */
export interface DatabasePages {
    /**
     * 
     * @type {DatabasePage}
     * @memberof DatabasePages
     */
    landing?: DatabasePage;
    /**
     * 
     * @type {DatabasePage}
     * @memberof DatabasePages
     */
    closing?: DatabasePage;
    /**
     * 
     * @type {DatabasePage}
     * @memberof DatabasePages
     */
    infoText?: DatabasePage;
    /**
     * 
     * @type {DatabaseLinkGalleryPage}
     * @memberof DatabasePages
     */
    linkGallery?: DatabaseLinkGalleryPage;
}

/**
 * Check if a given object implements the DatabasePages interface.
 */
export function instanceOfDatabasePages(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabasePagesFromJSON(json: any): DatabasePages {
    return DatabasePagesFromJSONTyped(json, false);
}

export function DatabasePagesFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabasePages {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'landing': !exists(json, 'landing') ? undefined : DatabasePageFromJSON(json['landing']),
        'closing': !exists(json, 'closing') ? undefined : DatabasePageFromJSON(json['closing']),
        'infoText': !exists(json, 'infoText') ? undefined : DatabasePageFromJSON(json['infoText']),
        'linkGallery': !exists(json, 'linkGallery') ? undefined : DatabaseLinkGalleryPageFromJSON(json['linkGallery']),
    };
}

export function DatabasePagesToJSON(value?: DatabasePages | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'landing': DatabasePageToJSON(value.landing),
        'closing': DatabasePageToJSON(value.closing),
        'infoText': DatabasePageToJSON(value.infoText),
        'linkGallery': DatabaseLinkGalleryPageToJSON(value.linkGallery),
    };
}

